import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'height'
})
export class HeightPipe implements PipeTransform {

  transform(heightInches: string | undefined): string {
    if (!heightInches) {
      return '';
    }
    const height = Number(heightInches);
    const feet = Math.floor(height / 12);
    const inches = height % 12;
    return `${feet} ft. ${inches} in.`;
  }
}